<div style="display: none">
  <app-svg-icon></app-svg-icon>
</div>
@if(!isPrintPage()) {
<app-header></app-header>
}
<div class="wrapper" [class.print-container]="isPrintPage()">
  <router-outlet></router-outlet>
  <app-network-error-popup></app-network-error-popup>
</div>
